import { DocumentNode } from "@apollo/client";

import gql from "graphql-tag";
import { PureQueryOptions } from "@apollo/client";
import { GraphQlQueryBuilder } from "./graphQl-query.builder";

export class DataTypeGraphQlBuilder {
  private get _query(): DocumentNode {
    return gql`
      query findallDataType {
        findTipoDatos {
          nombre
          nombre_es
          nombre_en
          descripcion
          factorDecimal
          unidad
          codigo
          uuid
          displayField
          codigo
          hideCode
          agrupacion {
            uuid
            nombre
            nombre_es
            nombre_en
            hideCode
            agrupacion {
              uuid
              nombre
              nombre_es
              nombre_en
              hideCode
              agrupacion {
                uuid
                nombre
                nombre_es
                nombre_en
                hideCode
                agrupacion {
                  uuid
                  nombre
                  nombre_es
                  nombre_en
                  hideCode
                }
              }
            }
          }
        }
      }
    `;
  }

  public build(): PureQueryOptions {
    const graphQlBuilder: GraphQlQueryBuilder = new GraphQlQueryBuilder();
    return graphQlBuilder.withQuery(this._query).build();
  }
}
